import { createContext } from "react";
import { NamedProperty } from "sprint-common-web";

import { AssetListingConfig } from "../../common/config/AssetListingConfig";
import { TvSeriesCatalogueEntry } from "./TvSeriesCatalogueEntry";

interface ISingleTvSeriesContext {
    tvSeries?: TvSeriesCatalogueEntry;
    isLoading: boolean;
    listingConfig: AssetListingConfig;
    saveListingConfig: (config: AssetListingConfig) => void;
}

export interface VersionDetails {
    versionTypes: NamedProperty[];
    distributors: NamedProperty[];
    brandings: NamedProperty[];
}

const defaultSingleTvSeriesContext: ISingleTvSeriesContext = {} as ISingleTvSeriesContext;

export const SingleTvSeriesContext = createContext<ISingleTvSeriesContext>(defaultSingleTvSeriesContext);
